// Phase 67 D-22: Dropbox storage save endpoints. Manual ADMIN+ACCOUNTANT push.
// Idempotent on the backend — second call returns the cached {url,fileId,savedAt,cached:true}.
import apiClient from './client.js';

export const saveContractToDropbox = async (contractId) => {
  const { data } = await apiClient.post(`/contracts/${contractId}/save-to-dropbox`);
  return data;  // { url, fileId, savedAt, cached }
};

export const saveInvoiceToDropbox = async (invoiceId) => {
  const { data } = await apiClient.post(`/invoices/${invoiceId}/save-to-dropbox`);
  return data;
};

export const saveTerminationToDropbox = async (terminationId) => {
  const { data } = await apiClient.post(`/terminations/${terminationId}/save-to-dropbox`);
  return data;
};
